import { render, staticRenderFns } from "./Canceled.vue?vue&type=template&id=25b4b8ed&scoped=true"
import script from "./Canceled.vue?vue&type=script&lang=js"
export * from "./Canceled.vue?vue&type=script&lang=js"
import style0 from "./Canceled.vue?vue&type=style&index=0&id=25b4b8ed&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b4b8ed",
  null
  
)

export default component.exports